// import {
//     FilterRowProps,
// } from "../../../components/UtilitiesComponent/FilterRow";
import assest from "../../../json/assest";
// import Image from "next/image";
import React, { useState } from "react";
import styles from "../../../styles/pages/home.module.scss";
import styles1 from "../../../styles/components/ClearedPageTable/clearedTable.module.scss";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../UtilitiesComponent/Pagination";
import AllPurchasedFilterModal from "../../FilterModal/AllPurchasedFilterModal";
// import { useRouter } from "next/router";
import PublishedFilter from "../../AllFilterRow/ClearedPageFilter/PublishedFilter";
import { Link, useNavigate } from "react-router-dom";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcDateTime,
  getUtcTime,
  roleFinder,
} from "../../../lib/functions/utils.lib";
import AllPublishedclearModal from "../../FilterModal/AllPublishedclearModal";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import EmptyTable from "../../EmptyTable/EmptyTable";
import { useAppSelector } from "../../../hooks/useAppSelector";
import Filter from "../../Filter/Filter";
import NoResult from "../../NoResult/NoResult";
import VideoPageFullModal from "../../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../../VideoPages/pages/WatchVideoModal";
// import Link from "next/link";

function createData(
  VSID,
  Acquisitor,
  Thumbnail,
  Title,
  SubmitterName,
  EmailAddress,
  SubmissionDate,
  UploadURL
) {
  return {
    VSID,
    Acquisitor,
    Thumbnail,
    Title,
    SubmitterName,
    EmailAddress,
    SubmissionDate,
    UploadURL,
  };
}

export default function ClearedPublishTable(props) {
  const {
    filterRowProps,
    datas,
    handlePageChange,
    filterRefetch,
    p,
    handleClearFilterModal,
    getmounth,
    getyear,
  } = props;

  console.warn("datas", datas);
  // const route = useRouter();
  const navigate = useNavigate();
  const {
    manager_id,
    published,
    purchased,
    user_id,
    month,
    year,
    submit_place,
    has_note,
    unreachable_submitter,
    hasMessage,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
    confirmed,
    apiActiveTwo,
  } = useAppSelector((s) => s.publishedCleareddSlice);

  const shouldHideTableHeadAndFilter =
    datas?.data.length === 0 &&
    !manager_id &&
    !published &&
    !purchased &&
    !month &&
    !year &&
    !submit_place &&
    !has_note &&
    !unreachable_submitter &&
    !hasMessage &&
    !people_appearing &&
    !person_who_filmed &&
    !submit_other_website &&
    !aggrement_with_another_company &&
    !from &&
    !to;

  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    p.handleTriggreFetch();
  };

  const [openModalTwo, setOpenModalTwo] = useState(false);

  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  return (
    <Box
      className={
        datas?.data.length > 0
          ? `${styles.table_sec} ${styles1.clearedTable}`
          : `${styles.table_sec}  ${
              manager_id ||
              published ||
              purchased ||
              month ||
              year ||
              submit_place ||
              has_note ||
              unreachable_submitter ||
              hasMessage ||
              people_appearing ||
              person_who_filmed ||
              submit_other_website ||
              aggrement_with_another_company
                ? `${styles1.table_sec_noFilter}`
                : `${styles1.table_sec_noData}`
            }`
      }
    >
      <Box className={`${styles.table_top} ${styles1.tabletopCleared}`}>
        <PublishedFilter
          {...filterRowProps}
          // FilterModalComponent={AllPurchasedFilterModal}
          datas={datas}
          getmounth={getmounth}
          getyear={getyear}
          FilterModalComponent={AllPublishedclearModal}
          filterModalProps={{
            hideBottom: true,
            filterRefetch,
            handleClearFilterModal,
            p,
          }}
        />
      </Box>
      {!shouldHideTableHeadAndFilter && (
        <Box
          className={`${styles1.clearedPublishTableTop} ${styles1.clearedPublishTablpub}`}
        >
          <Box
            className={`${styles1.clearedPublish} ${styles1.clearedtablecontnrs}`}
          >
            {/* <PerfectScrollbar className={styles1.clearedScrollNoData}> */}
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="sticky table">
                {!shouldHideTableHeadAndFilter && (
                  <TableHead>
                    <TableRow>
                      <TableCell className={styles1.visd}>VSID</TableCell>
                      <TableCell className={styles1.acqui}>
                        Acquisitor
                      </TableCell>
                      <TableCell className={styles1.thumb}>Thumbnail</TableCell>
                      <TableCell className={styles1.title}>Title</TableCell>
                      <TableCell className={styles1.submitter}>
                        Submitter Name
                      </TableCell>
                      <TableCell className={styles1.email}>
                        Email Address
                      </TableCell>
                      <TableCell className={styles1.submission}>
                        Publishing Date
                      </TableCell>
                      <TableCell className={styles1.upload}>
                        Upload URL
                      </TableCell>
                      <TableCell className={styles1.view}>View</TableCell>
                    </TableRow>
                  </TableHead>
                )}

                <TableBody>
                  {datas?.data.length > 0 ? (
                    <>
                      {datas?.data.map((row, index) => (
                        <>
                          <TableRow key={index}>
                            <TableCell>
                              <Box className={styles1.vsid_code}>
                                <p>{row.id}</p>
                                {row.unseen_messages ? (
                                  <span className={styles.vsid_circ}></span>
                                ) : (
                                  <></>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box className={styles1.acquisitor}>
                                {row.user?.name} {row.user?.last_name}
                                <span>
                                  <p className={styles1.table_customer}>
                                    {roleFinder(row.user?.role_id)}
                                  </p>
                                </span>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box className={styles1.publishThumb}>
                                <figure className={styles1.thumb_img}>
                                  <img
                                    onClick={() => onOpenTwo(row.id)}
                                    src={concatHostAndImagePath(row.thumbnail)}
                                  />
                                </figure>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <p className={styles1.titleBox}>{row.title}</p>
                            </TableCell>
                            <TableCell>
                              {" "}
                              <Box className={styles1.submitterName}>
                                {row.first_name} {row.last_name}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box className={styles1.emailsec}>
                                {row.email}
                              </Box>
                              {row.unreachable_submitter ? (
                                <p className={styles1.red_email}>
                                  Unreachabtotalle Email
                                </p>
                              ) : (
                                <></>
                              )}
                            </TableCell>
                            <TableCell>
                              {getUtcDate(row.created_at)} <br />
                              {getUtcTime(row.created_at)}
                            </TableCell>
                            <TableCell>
                              <Link href="" className={styles1.video_url_row}>
                                {row.video_url}
                              </Link>
                            </TableCell>
                            <TableCell>
                              {/* <Link
                            to={`/video/${row.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          > */}
                              <Box
                                className={`${styles1.table_view} ${styles1.table_view_url}`}
                              >
                                {/* <img
                                src={assest.tableview}
                                width={16}
                                height={16}
                                alt=""
                              /> */}

                                <img
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onOpen(row.vsid)}
                                  src={assest.IconView}
                                  width={16}
                                  height={16}
                                  alt="icon"
                                />
                              </Box>
                              {/* </Link> */}
                            </TableCell>
                          </TableRow>

                          <TableRow key={row.id} className={styles1.blnkTd}>
                            <TableCell colSpan={9}>{""}</TableCell>
                          </TableRow>
                        </>
                      ))}
                    </>
                  ) : (
                    <TableRow className={styles1.paginationTble}>
                      {manager_id ||
                      published ||
                      purchased ||
                      month ||
                      year ||
                      submit_place ||
                      has_note ||
                      unreachable_submitter ||
                      hasMessage ||
                      people_appearing ||
                      person_who_filmed ||
                      submit_other_website ||
                      aggrement_with_another_company ? (
                        <TableCell colSpan={9} className={styles1.borderNone}>
                          <Filter resetFilters={props?.filtersReset} />
                        </TableCell>
                      ) : (
                        <>
                          {from || to ? (
                            <TableCell
                              colSpan={9}
                              className={styles1.borderNone}
                            >
                              <NoResult heading={"published"} />
                            </TableCell>
                          ) : (
                            <TableCell
                              colSpan={9}
                              className={styles1.borderNone}
                            >
                              <EmptyTable
                                emptyTableText={
                                  // "You have no approved videos at the moment. Please reload the page or check back later."
                                  "No videos have been published yet. Please check back later or refresh the page."
                                }
                              />
                            </TableCell>
                          )}
                        </>
                      )}
                    </TableRow>
                  )}

                  <TableRow className={styles1.paginationTble}>
                    <TableCell colSpan={10} sx={{ border: "none !important" }}>
                      {datas?.data.length > 0 && datas?.last_page > 1 ? (
                        <Pagination
                          page={props?.page}
                          lastpage={datas?.last_page}
                          sendDataToParent={props?.handlePageChange}
                        />
                      ) : (
                        ""
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {/* </PerfectScrollbar> */}
          </Box>

          <WatchVideoModal
            onClose={onCloseTwo}
            open={openModalTwo}
            id={id}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videoPageModal"
          />

          <VideoPageFullModal
            onClose={onClose}
            open={openModal}
            id={id}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="videoPageModal"
          />
        </Box>
      )}
    </Box>
  );
}
